import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25.09,
	height: 17.676,
	viewBox: "0 0 25.09 17.676",
	...props,
	children: [/* @__PURE__ */ _jsx("line", {
		x2: 7.424,
		y2: 5.939,
		transform: "translate(1.406 10.323)",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("line", {
		y1: 14.847,
		x2: 14.847,
		transform: "translate(8.829 1.414)",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 2
	})]
});
export default SvgCheck;
